import React from "react";
import { Auth } from "aws-amplify";

import { LinkContainer } from "react-router-bootstrap";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Button from "react-bootstrap/Button";
import NavDropdown from "react-bootstrap/NavDropdown";

import { LoginContext } from "./LoginContext";
import { CartItem } from "./GoelysRestoTypes";

import Logo_goelys from "./logo_goelys.svg";
import IconCart from "./assets/images/icon_cart.svg";

import "./Header.css";

interface HeaderProps {
  cart?: CartItem[];
  canOrder?: boolean;
  user?: any;
}

export function Header({ cart, canOrder, user }: HeaderProps) {
  let spanClassName = "icon_cart";
  if (cart && cart.length) {
    spanClassName += " show";
    const span = document.querySelector("span.icon_cart");
    span?.setAttribute("data-content", cart.length.toString());
  }
  return (
    <header>
      <Navbar bg="light" expand="lg">
        <Navbar.Brand href="/">
          <img className="img_logo" src={Logo_goelys} alt="Logo Goelys"></img>
        </Navbar.Brand>
        {cart && canOrder && (
          <Nav.Link href="panier" className="ml-auto">
            <span className={spanClassName}>
              <img
                src={IconCart}
                className="icon_cart"
                alt="Icône de panier de commande"
              />
            </span>
          </Nav.Link>
        )}
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ml-auto">
            <Nav.Link href="/#contact">Contact</Nav.Link>
            {user ? (
              <NavDropdown
                className="header_user_dropdown mx-auto"
                id="header_user_dropdown"
                title={user.signInUserSession.idToken.payload.email}
              >
                {/*<NavDropdown.Item href="/user/compte">Mon compte</NavDropdown.Item>*/}
                <LinkContainer to="/user/restaurant">
                  <NavDropdown.Item>Mon restaurant</NavDropdown.Item>
                </LinkContainer>
                <NavDropdown.Divider />
                <NavDropdown.Item as="button" onClick={() => Auth.signOut()}>
                  Se déconnecter
                </NavDropdown.Item>
              </NavDropdown>
            ) : (
              <Button className="" onClick={() => Auth.federatedSignIn()}>
                Se connecter / S'inscrire
              </Button>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </header>
  );
}
